import { render } from "./InventoryTypes.vue?vue&type=template&id=6a4b7429&scoped=true"
import script from "./InventoryTypes.vue?vue&type=script&lang=ts"
export * from "./InventoryTypes.vue?vue&type=script&lang=ts"

import "./InventoryTypes.vue?vue&type=style&index=0&id=6a4b7429&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6a4b7429"

export default script